<template>
<!--
    <figure class="text-center">
        <blockquote class="blockquote">
            <p>A well-known quote, contained in a blockquote element.</p>
        </blockquote>
        <figcaption class="blockquote-footer">
            Someone famous in <cite title="Source Title">Source Title</cite>
        </figcaption>
    </figure>
-->
    <figure class="text-center">
        <div class="section mt-4">
            <div class="row">
                <div class="col-lg-2">
                </div>
                <div class="col-lg-8">
                    <div class="card shadow p-3">
                        <div class="row">
                            <div class="col-3 d-flex">
                                <!-- <img :src="image" class="rounded float-left" style="width: 100%;" alt=""> -->
                                <img :src="image" class="rounded float-left" style="height: 100px;" alt="">
                            </div>
                            <figure class="text-center col-9">
                                <blockquote class="blockquote">
                                    <p style="font-style: italic">{{text}}</p>
                                </blockquote>
                                <figcaption class="blockquote-footer">
                                    <!-- Someone famous in <cite title="Source Title">Source Title</cite> -->
                                    {{fio}}
                                </figcaption>
                            </figure>        
                        </div>
                    </div>
                </div>
                <div class="col-lg-2">
                </div>
            </div>     
        </div>
    </figure>
</template>


<script>
export default {
    data() {
        return {
            images: ['/images/person1.jpg', '/images/person2.jpg'],
            texts: [
                'Я добавляю информацию о пройденных курсах в своё резюме, это выделяет меня на фоне других специалистов.',
                'Здесь широкий выбор курсов, профессиональные преподаватели, именно это мотивирует меня продолжать обучение.'
                ],
            fios: [
                'Марина Ч., 32 года',
                'Сергей К., 38 лет',
            ],
            image: '',
            text: '',
            fio: '',
        }
    },
    mounted() {
        var i = this.getRandomInt(0,2)
        this.image = this.images[i]
        this.text = this.texts[i]
        this.fio = this.fios[i]
    },
    props: {
        title: String,
        admin: Boolean,
    },
    methods: {
        getRandomInt(min, max) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min)) + min; //Максимум не включается, минимум включается
        }
    },


}
</script>

<style scoped>

</style>